import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { DebugLogger } from './debug-logger.service';
import { environment } from '@orderna/admin-panel/src/environments/environment';

@Component({
  selector: 'app-debug-logger',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './debug-logger.component.html',
})
export class DebugLoggerComponent {
  #logger = inject(DebugLogger);

  text = this.#logger.text;
  isDev =
    environment.baseUrl.includes('127.0.0.1') ||
    environment.baseUrl.includes('localhost') ||
    environment.baseUrl.includes('dev');
  show = signal(false);

  async copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.text());
    } catch (e) {
      console.error('Failed to copy debug logs.', e);
    }
  }

  clear(): void {
    this.#logger.clear();
  }

  toggle() {
    this.show.set(!this.show());
  }
}
